// extracted by mini-css-extract-plugin
export var logo = "_j3-2";
export var logoWrapper = "_j3-1";
export var strip = "_j3-0";